<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Rütbe</label>
            <v-validator :errors="errors" parameter="MilitaryTitleId" :watch="title">
                <v-select-list v-model="title" :options="militaryTitles" label="Name" placeholder="Rütbe"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <v-validator :errors="errors" parameter="StartDate" :watch="value.StartDate">
                <v-date-picker v-model="value.StartDate" placeholder="Başlangıç Tarihi"></v-date-picker>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Bitiş Tarihi</label>
            <v-validator :errors="errors" parameter="EndDate" :watch="value.EndDate">
                <v-date-picker v-model="value.EndDate" placeholder="Bitiş Tarihi"></v-date-picker>
            </v-validator>
        </div>
    </div>
</template>

<script>
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
import VValidator from '@/components/VValidator.vue';
import SystemDataApi from '@/api/system-data';

export default {
    components:{
        VValidator
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            militaryTitles:[],
            values:[],
        }
    },
    mounted(){
        this.getMilitaryTitles()
    },
    methods:{
        getMilitaryTitles(){
            SystemDataApi.MilitaryTitle().then(res=>{
                this.militaryTitles = res.data.Data
            })
        }
    },
    computed:{
        title:{
            get:function(){
                return this.militaryTitles.find(b=>b.Id==this.value.MilitaryTitleId)
            },
            set:function(value){
                this.value.MilitaryTitleId = value?.Id || null
                this.value.MilitaryTitleName = value?.Name
            }
        },
    }
}
</script>

<style>

</style>